import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RssFeedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rss_feed"}/>
}
